"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlParams = getUrlParams;
exports.resolveUrlParams = resolveUrlParams;
exports.constructUrlParams = constructUrlParams;
exports.qsm = qsm;
exports["default"] = exports.URL_TOGGLE = exports.URL_SET = exports.URL_REMOVE = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var URL_REMOVE = 'remove';
exports.URL_REMOVE = URL_REMOVE;
var URL_SET = 'set';
exports.URL_SET = URL_SET;
var URL_TOGGLE = 'toggle';
exports.URL_TOGGLE = URL_TOGGLE;

function filterByParamName(paramName) {
  return function (param) {
    return param.key === paramName;
  };
}

function findParamIndex(params, paramName) {
  return params.findIndex(filterByParamName(paramName));
}

function removeParam(params, paramName) {
  var paramIndex;

  do {
    paramIndex = params.findIndex(filterByParamName(paramName));

    if (paramIndex !== -1) {
      params.splice(paramIndex, 1);
    }
  } while (paramIndex !== -1);
}

function findQueryStart(url) {
  return url.indexOf('?');
}

function removeParams(urlParams, params) {
  return params.forEach(function (paramName) {
    return removeParam(urlParams, paramName);
  });
}

function mapInputKeyToParam(params, key) {
  return {
    key: key,
    value: params[key],
    encode: true
  };
}

function mapInputToParams(params) {
  return Object.keys(params).filter(function (key) {
    return params[key] !== undefined;
  }).reduce(function (aggr, key) {
    if (params[key] instanceof Array) {
      return aggr.concat(params[key].map(function (value) {
        return {
          key: key,
          value: value,
          encode: true
        };
      }));
    }

    return [].concat(_toConsumableArray(aggr), [mapInputKeyToParam(params, key)]);
  }, []);
}

function toggleParams(urlParams, urlParamsNext, params) {
  Object.keys(params).forEach(function (key) {
    var paramIndex = findParamIndex(urlParams, key);
    var value = params[key];

    if (paramIndex === -1) {
      urlParamsNext.push({
        key: key,
        value: value
      });
    } else {
      var param = urlParams[paramIndex];

      if (param.value === value) {
        removeParam(urlParams, key);
      } else {
        urlParamsNext.push({
          key: key,
          value: value
        });
      }
    }
  });
}

function getUrlParams(url) {
  var decodedUrl = decodeURI(url);
  var queryStart = findQueryStart(decodedUrl);
  var urlParamPairs = queryStart === -1 ? [] : decodedUrl.substr(queryStart + 1).split('&');
  return urlParamPairs.filter(function (param) {
    return param;
  }).map(function (paramPair) {
    var _paramPair$split = paramPair.split('='),
        _paramPair$split2 = _slicedToArray(_paramPair$split, 2),
        key = _paramPair$split2[0],
        value = _paramPair$split2[1];

    return {
      key: key,
      value: value
    };
  });
}

function resolveUrlParamsWithNotes(prevParams, paramActions) {
  var urlParams = prevParams.slice();
  var urlParamsNext = paramActions[URL_SET] ? mapInputToParams(paramActions[URL_SET]) : [];

  if (paramActions[URL_TOGGLE]) {
    toggleParams(urlParams, urlParamsNext, paramActions[URL_TOGGLE]);
  }

  if (paramActions[URL_REMOVE]) {
    removeParams(urlParams, paramActions[URL_REMOVE]);
  }

  return [].concat(_toConsumableArray(urlParams.filter(function (param) {
    return findParamIndex(urlParamsNext, param.key) === -1;
  })), _toConsumableArray(urlParamsNext));
}

function resolveUrlParams(prevParams, paramActions) {
  return resolveUrlParamsWithNotes(prevParams, paramActions).map(function (param) {
    return {
      key: param.key,
      value: param.value
    };
  });
}

function constructUrlParams(params) {
  return params.map(function (param) {
    var key = param.encode ? encodeURIComponent(param.key) : param.key;
    return param.value === null ? "".concat(key) : "".concat(key, "=").concat(param.encode ? encodeURIComponent(param.value) : param.value);
  }).join('&');
}

function qsm(url) {
  var paramActions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!url || typeof url !== 'string') {
    return null;
  }

  var params = constructUrlParams(resolveUrlParamsWithNotes(getUrlParams(url), paramActions));
  var queryStart = findQueryStart(url);
  var strippedUrl = queryStart === -1 ? url : url.substr(0, queryStart);
  return params.length === 0 ? strippedUrl : "".concat(strippedUrl, "?").concat(params);
}

var _default = qsm;
exports["default"] = _default;